import React from 'react';

export const LoadingScreen: React.FC = () => {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="text-center">
        <div className="mb-8">
          <div className="inline-block animate-spin rounded-full h-12 w-12 border-4 border-primary border-t-transparent"></div>
        </div>
        <h1 className="text-2xl font-bold text-foreground mb-2">
          Tower Wars Evolution
        </h1>
        <p className="text-muted-foreground">
          Loading your gaming experience...
        </p>
      </div>
    </div>
  );
};